import script from "./top-item.vue?vue&type=script&setup=true&lang=js"
export * from "./top-item.vue?vue&type=script&setup=true&lang=js"

import "./top-item.vue?vue&type=style&index=0&id=3c389b5b&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c389b5b"]])

export default __exports__